import React from 'react';

const AnimatedBubblesBackground: React.FC = () => (
  <div className="absolute inset-0 pointer-events-none z-0">
    <div className="bubble bubble-1"></div>
    <div className="bubble bubble-2"></div>
    <div className="bubble bubble-3"></div>
    <div className="bubble bubble-4"></div>
    <div className="bubble bubble-5"></div>
    <div className="bubble bubble-6"></div>
    <div className="bubble bubble-7"></div>
    <div className="bubble bubble-8"></div>
    <div className="bubble bubble-9"></div>
    <div className="bubble bubble-10"></div>
  </div>
);

export default AnimatedBubblesBackground; 